export default "__VITE_ASSET__Dc30UHD2__"